<template lang="html">
  <PageHeader />
  <ComingSoon />
  <PageFooter />
</template>

<script lang="js">
import PageHeader from '@/components/commons/PageHeader.vue';
import PageFooter from '@/components/commons/PageFooter.vue';
import ComingSoon from '@/components/partials/ComingSoon.vue';

export default {
  name: 'AffiliateProgram',
  props: [],
  components: {
    PageHeader,
    PageFooter,
    ComingSoon,
  },
  mounted() {

  },
  data() {
    return {

    };
  },
  methods: {

  },
  computed: {
  },
};
</script>

<style scoped lang="scss"></style>
